/* Bean Shipper — Receipts landing (/pages/receipts). Behaviour for sections/page__bs-receipts.liquid:
   the grind chips, the variant id for whichever add button was pressed (its size, the chosen grind),
   ?variant= for ad links, the jump from the offer boxes and "choose a grind here" to the buy box,
   the jump from the hero rating to the reviews, the cap on Loox's full review list ("Show all N
   reviews"), the mobile pill, a one-open-at-a-time accordion and the cold-traffic flag.
   Motion (29 Sep 2026): scroll reveals and stagger indices, the count-ups, the hero parallax, loops
   that pause off screen, the review row's progress bar and one-time nudge, and a bump on any button
   label whose price changes. All transform-only; the page is complete at rest without any of it.
   The add itself is the theme's ajax cart: form[data-bs-add] + [data-bs-pdp-add]. */
(function () {
  function motion(root, reduce) {
    var io = 'IntersectionObserver' in window;

    // Stagger indices: each child of [data-bsrc-stagger] waits its turn (--i x 80ms in the CSS).
    var rv = Array.prototype.slice.call(root.querySelectorAll('[data-bsrc-rv],[data-bsrc-stagger]'));
    rv.forEach(function (el) {
      if (el.hasAttribute('data-bsrc-stagger')) {
        Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--i', i); });
      }
    });

    // Count-up: 0 -> the rendered figure, eased over 1.1s. Keeps the figure's prefix and suffix
    // ("RM", " cups") and pads with figure spaces so the line never re-wraps mid-count.
    function countUp(num, delay) {
      if (reduce || num.__bsrcCount) return;
      num.__bsrcCount = true;
      var target = num.getAttribute('data-bsrc-count') || '';
      var m = target.match(/^(\D*)(\d+(?:\.\d+)?)(.*)$/);
      if (!m) return;
      var pre = m[1], end = parseFloat(m[2]), post = m[3];
      var dec = (m[2].split('.')[1] || '').length, width = m[2].length;
      function show(v) {
        var s = v.toFixed(dec);
        while (s.length < width) s = ' ' + s;
        num.textContent = pre + s + post;
      }
      // 19 Oct 2026: the figure keeps its final width while it counts. Athena's digits are proportional,
      // so every frame was a different width and the hero headline re-wrapped: everything under it jumped
      // a line (30px) and back, over and over (CLS 0.25 on phones). Same box, same wrap, no reflow.
      var w0 = num.getBoundingClientRect().width;
      if (w0 > 0) {
        num.style.display = 'inline-block';
        num.style.width = Math.ceil(w0) + 'px';
        num.style.whiteSpace = 'nowrap';
      }
      show(0);
      setTimeout(function () {
        var t0 = null;
        requestAnimationFrame(function step(ts) {
          if (!t0) t0 = ts;
          var k = Math.min(1, (ts - t0) / 1100);
          show(end * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(step); else num.textContent = target;
        });
      }, delay || 0);
    }

    // Reveals: threshold 0 (a sliver is enough, so tall blocks never miss), and anything already
    // above the viewport when observed reveals at once. Revealing also starts its count-ups.
    function reveal(el) {
      if (el.classList.contains('is-in')) return;
      el.classList.add('is-in');
      Array.prototype.forEach.call(el.querySelectorAll('[data-bsrc-count-rv]'), function (n) { countUp(n, 150); });
    }
    if (reduce || !io) {
      rv.forEach(reveal);
    } else {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { reveal(e.target); rio.unobserve(e.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      rv.forEach(function (el) { rio.observe(el); });
    }

    // The hero's per-cup figure counts up on load.
    var heroNum = root.querySelector('.bsrc-hero [data-bsrc-count]');
    if (heroNum) countUp(heroNum, 350);

    // Loops (marquees, slow zooms, glints) pause while their block is off screen.
    if (io) {
      var lio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
      }, { threshold: 0 });
      Array.prototype.forEach.call(root.querySelectorAll('[data-bsrc-loop]'), function (el) { lio.observe(el); });
    }

    // Hero parallax: the photo drifts up at 8% of scroll, desktop only (transform on the img;
    // the slow zoom runs on its wrapper, so the two never fight).
    var par = root.querySelector('[data-bsrc-parallax] img');
    if (par && !reduce) {
      var pTick = false;
      var onScroll = function () {
        if (pTick) return;
        pTick = true;
        requestAnimationFrame(function () {
          pTick = false;
          if (!window.matchMedia('(min-width: 1024px)').matches) { par.style.transform = ''; return; }
          var y = Math.min(window.pageYOffset, 900);
          par.style.transform = 'translateY(' + (-y * 0.08).toFixed(1) + 'px)';
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }

    // Review row (under 1024px it swipes): a progress line under it, and one nudge the first
    // time it is mostly on screen, so it reads as something that moves.
    var wall = root.querySelector('[data-bsrc-wall]');
    var prog = root.querySelector('[data-bsrc-prog]');
    if (wall && prog) {
      var wTick = false;
      var upd = function () {
        wTick = false;
        var p = wall.scrollWidth > 0 ? (wall.scrollLeft + wall.clientWidth) / wall.scrollWidth : 1;
        prog.style.transform = 'scaleX(' + Math.min(1, Math.max(0.05, p)).toFixed(3) + ')';
      };
      wall.addEventListener('scroll', function () {
        if (!wTick) { wTick = true; requestAnimationFrame(upd); }
      }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
      if (!reduce && io) {
        var nio = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          nio.disconnect();
          if (wall.scrollWidth > wall.clientWidth + 4 && wall.scrollLeft < 4) wall.classList.add('is-nudge');
        }, { threshold: 0.6 });
        nio.observe(wall);
      }
    }
  }

  function init() {
    var root = document.querySelector('[data-bsrc]');
    if (!root || root.__bsrc) return;
    root.__bsrc = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Cold traffic: no subscription pitch in the cart drawer for the rest of this session,
    // the same flag /pages/fresh sets (the drawer snippet reads it on every page). sessionStorage
    // is the main carrier: declining the cookie banner purges cookies it doesn't know.
    document.documentElement.classList.add('bs-cold');
    try { sessionStorage.setItem('bs_cold', '1'); } catch (e) {}
    try { document.cookie = 'bs_cold=1; path=/; SameSite=Lax'; } catch (e) {}

    // Motion first: it needs nothing from the variant map below.
    motion(root, reduce);

    // Loox's full review list can run to thousands of pixels, so its box is capped in the CSS.
    // The button opens it; while the list is shorter than the cap (or before Loox has filled it)
    // the button and the fade stay hidden.
    var lbox = root.querySelector('[data-bsrc-loox]');
    var lmore = root.querySelector('[data-bsrc-loox-more]');
    if (lbox && lmore) {
      var fitLoox = function () {
        if (lbox.classList.contains('is-open')) return;
        var short = lbox.scrollHeight <= lbox.clientHeight + 4;
        lbox.classList.toggle('is-short', short);
        lmore.hidden = short;
      };
      lmore.addEventListener('click', function () {
        lbox.classList.add('is-open');
        lmore.hidden = true;
        lmore.setAttribute('aria-expanded', 'true');
      });
      var lw = lbox.querySelector('#looxReviews');
      if (lw && 'ResizeObserver' in window) new ResizeObserver(fitLoox).observe(lw);
      window.addEventListener('load', fitLoox);
      setTimeout(fitLoox, 4000);
      fitLoox();
    }

    function hdr() { return window.matchMedia('(min-width: 768px)').matches ? 89 : 78; }
    function scrollToEl(el, pad) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - hdr() - (pad || 0);
      try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, top); }
    }

    // The hero rating jumps to the reviews (below the fixed header), with or without the variant map.
    root.addEventListener('click', function (e) {
      var toR = e.target.closest('[data-bsrc-toreviews]');
      if (!toR) return;
      var tg = document.getElementById('bsrc-reviews');
      if (!tg) return;
      e.preventDefault();
      scrollToEl(tg, 8);
    });

    var idInput = root.querySelector('[data-bsrc-id]');
    var variants = (root.getAttribute('data-vmap') || '').split('||').map(function (e) {
      var p = e.split('~');
      return { id: p[0], size: p[1], grind: p[2], avail: p[3] === 'true' };
    }).filter(function (v) { return v.id; });
    if (!idInput || !variants.length) return;

    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-bsrc-grind]'));
    var rungs = Array.prototype.slice.call(root.querySelectorAll('[data-bsrc-rung]')).map(function (el) {
      return { el: el, size: el.getAttribute('data-bsrc-rung'), verb: el.getAttribute('data-verb'), price: el.getAttribute('data-price') };
    });
    function rungFor(size) {
      for (var i = 0; i < rungs.length; i++) if (rungs[i].size === size) return rungs[i];
      return null;
    }

    // Opening state = the variant the form was rendered with.
    var state = { main: variants[0].size, grind: variants[0].grind };
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === idInput.value) { state.main = variants[i].size; state.grind = variants[i].grind; }
    }

    function find(size, grind) {
      var fallback = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.size !== size) continue;
        if (v.grind === grind) return v;
        if (!fallback) fallback = v;
      }
      return fallback;
    }
    function sizeOf(btn) {
      var s = btn.getAttribute('data-bsrc-size');
      return s === 'main' ? state.main : s;
    }

    // A button label whose text changed after load does a small bump (transform keyframe).
    var ready = false;
    function bump(el) {
      if (reduce || !ready) return;
      el.classList.remove('bsrc-bump');
      void el.offsetWidth;
      el.classList.add('bsrc-bump');
    }

    function apply() {
      var label = state.grind;
      chips.forEach(function (c) {
        var on = c.getAttribute('data-bsrc-grind') === state.grind;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        if (on) label = c.getAttribute('data-label') || label;
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-bsrc-gname]'), function (s) { s.textContent = label; });
      rungs.forEach(function (r) { r.el.setAttribute('data-on', r.size === state.main ? 'true' : 'false'); });
      // Re-query every time: the ajax cart restores each button's innerHTML after an add,
      // which replaces the label spans, so cached references would go stale.
      Array.prototype.forEach.call(root.querySelectorAll('button[data-bsrc-size]'), function (b) {
        var size = sizeOf(b), v = find(size, state.grind), r = rungFor(size);
        var ok = !!(v && v.avail);
        b.disabled = !ok;
        var l = b.querySelector('[data-bsrc-lbl]');
        if (!l || !r) return;
        var before = l.textContent;
        if (!ok) l.textContent = 'Sold out';
        else if (b.hasAttribute('data-bsrc-pill')) l.textContent = r.price + ' · ' + r.verb;
        else l.textContent = r.verb + ' · ' + r.price;
        if (l.textContent !== before) bump(l);
      });
      var cur = find(state.main, state.grind);
      if (cur) idInput.value = cur.id;
    }

    // Jump to the buy box and outline it (the offer boxes and "choose a grind here").
    var buy = root.querySelector('[data-bsrc-buy]');
    var flashT = 0;
    function jump() {
      if (!buy) return;
      scrollToEl(buy, 16);
      buy.classList.add('is-flash');
      clearTimeout(flashT);
      flashT = setTimeout(function () { buy.classList.remove('is-flash'); }, 1600);
      var on = null;
      chips.forEach(function (c) { if (c.getAttribute('aria-checked') === 'true') on = c; });
      if (on) { try { on.focus({ preventScroll: true }); } catch (e) {} }
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var chip = t.closest('[data-bsrc-grind]');
      if (chip) { state.grind = chip.getAttribute('data-bsrc-grind'); apply(); return; }
      var go = t.closest('[data-bsrc-goto]');
      if (go) { e.preventDefault(); jump(); return; }
      // An add button: point the form's id at its size in the chosen grind before the
      // submit event reaches the ajax cart (which reads the form with FormData).
      var b = t.closest('button[data-bsrc-size]');
      if (b) {
        var v = find(sizeOf(b), state.grind);
        if (!v || !v.avail) { e.preventDefault(); return; }
        idInput.value = v.id;
      }
    });

    // ?variant= : a Shopify variant id from an ad link, or 300g / 2x300g / 1kg.
    try {
      var q = new URLSearchParams(window.location.search).get('variant');
      if (q) {
        var hit = null;
        for (var k = 0; k < variants.length; k++) if (variants[k].id === q) hit = variants[k];
        if (hit) { state.main = hit.size; state.grind = hit.grind; }
        else {
          var want = q.toLowerCase().replace(/\s+/g, '').replace('×', 'x');
          rungs.some(function (r) {
            var key = r.size.split(' - ')[0].toLowerCase().replace(/\s+/g, '');
            if (key === want) { state.main = r.size; return true; }
            return false;
          });
        }
      }
    } catch (e) {}
    apply();
    ready = true;

    // Pill: on from first paint; steps aside once the closing block is on screen or scrolled past.
    // A scroll check rather than an IntersectionObserver: a fast fling or a jump to the
    // footer can skip the closing block without it ever intersecting.
    var bar = root.querySelector('[data-bsrc-pillbar]');
    var close = root.querySelector('[data-bsrc-close]');
    var pillOn = null, ticking = false;
    function setPill(on) {
      if (!bar || on === pillOn) return;
      pillOn = on;
      bar.setAttribute('data-on', on ? 'true' : 'false');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var pb = bar.querySelector('button');
      if (pb) pb.tabIndex = on ? 0 : -1;
    }
    function checkPill() {
      ticking = false;
      setPill(close.getBoundingClientRect().top >= window.innerHeight);
    }
    function queuePill() {
      if (!ticking) { ticking = true; requestAnimationFrame(checkPill); }
    }
    if (bar && close) {
      window.addEventListener('scroll', queuePill, { passive: true });
      window.addEventListener('resize', queuePill);
      checkPill();
    }

    // Accordion: one question open at a time.
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-bsrc-faq] details'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
